// extracted by mini-css-extract-plugin
export var clickableWrapper = "_1v-2";
export var placeholderIcon = "_1v-3";
export var thumbnailCanvas = "_1v-1";
export var thumbnailWrapper = "_1v-0";